(function () {
  const mainImage = document.querySelector('[data-platforme-main-image]')
  const initialsInput = document.getElementById('personalization-popup_text-input')
  const initialsInputError = document.getElementById('personalization-popup_text-input-error')

  let variantId
  let lineItemProperies
  let currentShoeColor

  const ripeParams = {
    url: 'https://ripe-core.platforme.com/api/', // <- tests purposes only - Production URL: https://app.platforme.com/api/
    brand: 'cariuma',
    model: 'oca_low',
    options: {
      format: 'webp',
      errorPopup: false,
      remoteCalls: false,
      useMasks: false,
      usePrice: false,
      useSync: false,
    }
  }
  const ripe = new Ripe(ripeParams)

  initialsInput.addEventListener('input', setInitials)


  window.showCustomizationModal = function (selectedVariantId, productQueryParams, properties) {
    variantId = selectedVariantId
    lineItemProperies = properties
    document.getElementById('personalization-popup').classList.add('open');

    const ripeColor = getMatchingRipeColor(productQueryParams)

    console.log(currentShoeColor, ripeColor)

    if (currentShoeColor !== ripeColor) {
      mainImage.setAttribute('src', '')
    }
    currentShoeColor = ripeColor

    initRipe(ripeColor)

  };
  
  document.getElementById('confirmPersonalization').addEventListener('click', function () {
    // const variantId = JSON.parse(document.getElementById('variantIdPersonalizationModal').innerText);
    // const properties = JSON.parse(document.getElementById('lineItemPersonalizationModal').innerText);
    // const productQueryParams = JSON.parse(document.getElementById('contentPersonalizationModal').innerText);

    addToCart();
  });
  
  document.getElementById('closePersonalizationModal').addEventListener('click', closeCustomizationModal);

  // document.getElementById('confirmPersonalization').addEventListener('click', function () {
  //   const variantId = JSON.parse(document.getElementById('variantIdPersonalizationModal').innerText);
  //   const properties = JSON.parse(document.getElementById('lineItemPersonalizationModal').innerText);
  //   const productQueryParams = JSON.parse(document.getElementById('contentPersonalizationModal').innerText);

  //   addToCart(variantId, properties);
  // });

  function initRipe(ripeColor) {
    console.log(ripeColor)
    
    ripe.bindImage(mainImage, {
      frame: 'front-0',
      width: 720,
      showInitials: true,
      format: 'webp'
    })
    ripe.load();

    ripe.setPart('base', 'canvas', ripeColor)
    ripe.setInitials('', '')
  }

  function getMatchingRipeColor(productQueryParams) {
    const currentVariantColor = productQueryParams.options.filter(opt => opt.name === 'Colorway')[0].values[0]
    const { base: { materials: { canvas: { colors } } } } = ripe.getChoices()
    const canvasColors = Object.keys(colors)
    const matchingColor = canvasColors.find(c => currentVariantColor.toLowerCase().replaceAll('-', '_').includes(c))

    return matchingColor
  }

  function openCartDrawer() {

    /*
    const currentUrl = window.location.href;
    
    const newUrlSuffix = window.location.search.includes('?') ? '&miniCart' : '?miniCart';
  
    const newUrl = currentUrl + newUrlSuffix;
  
    window.location.href = newUrl;
    */

    cartDrawer.offcanvas('open');
  }

  function getInitialsColor() {
    return currentShoeColor === 'off_white' ? 'black' : 'white'
  }

  function setInitials(e) {
    // This regex matches emojis by checking for characters in the emoji range
    const regex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}]/gu;
    e.target.value = e.target.value.replace(regex, '');

    const initials = e.target.value.length === 0 ? '' : e.target.value.toUpperCase()
    const initialsColor = getInitialsColor()
    console.log(initialsColor)
    if (initials.length === 0) {
      ripe.setInitials('', '');
    } else {
      if (initials.length > 2) {
        e.target.classList.remove('error')
        initialsInputError.textContent = ''
      }
      ripe.setInitials(initials, initialsColor);
    }
  }

  function closeCustomizationModal() {
    document.getElementById('personalization-popup').classList.remove('open');
    ripe.setInitials('', '')
    initialsInput.value = ''
    initialsInputError.textContent = ''
    initialsInput.classList.remove('error')
  }

  function addToCart() {
    const initials = initialsInput.value.trim().toUpperCase()
    // console.log(initials);

    if (initials.length >= 2 && initials.length <= 8) {
      lineItemProperies.personalization = initials
      lineItemProperies._personalization = initials
      lineItemProperies._personalizationColor = getInitialsColor()

      lineItemProperies['_is_final_sale'] = 'true';
      
      console.log(lineItemProperies)
  
      CartJS.addItem(
        variantId,
        1,
        lineItemProperies,
        {
          "error": function (jqXHR, textStatus, errorThrown) {
            // Handle any errors here. 
            console.error("Error adding item to cart: ", textStatus, errorThrown);
          },
          "success": function (data, textStatus, jqXHR) {
            console.log("Item added to cart: ", data);
            closeCustomizationModal()
  
            //openCartDrawer(); 
  
          }
        }
      );
    } else {
      initialsInput.classList.add('error')
      initialsInputError.textContent = 'Please enter at least 2 characters'
    }
  }
})()